const authReducer = (state, action) =>{
    switch(action.type){
        case "SIGN_IN":
            return action.payload;
        
        case "SIGN_OUT":
            // localStorage.removeItem("AuthToken");
            // localStorage.removeItem("profileInfo");
            // localStorage.removeItem('announcement');
            const sidebarenabled = localStorage.getItem("sidebarEnabled");
            localStorage.clear();
            localStorage.setItem("sidebarEnabled",sidebarenabled);
            window.location = '/sign-in'; 
            break;
        default:
            return 0;  
    }
};

export default authReducer;